// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","white":"#ffffff","black":"#000000","light-grey":"#d4d4d4","faster":".2s","standard":"cubic-bezier(0.4, 0, 0.2, 1)","link":"_2IsAk0SxN3OBFG2lNhrXhd","medium":"_3US5I_po58MFCywKwNIj4j","dark":"_3oqTYuetRB-MNmZcvSdxEz","secondaryLight":"_2BOBCvY7oHxORRN7f1384","secondaryDark":"_1ObUuLY1wn3LdDU-rnN27d","s":"_1GoMhZjS59ZFgMh_7-Xjp5 _2aaMAHnruc9VlttWpaDHDT","m":"_376perKczHdUwW27tkwgNq _23sr_pdJne9VroucgJVQ64","l":"_3MOMK_Ae9gcf7qyOhGCkBN _13an9KTk-RIhXr-SEoW3hB","xl":"_12u-yKF3K73sPSKz91uDGj _10pC2eVuQXQqHo9p7H5j3Z"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Link/LinkWithinText/LinkWithinText.css
// module id = 971
// module chunks = 0